// extracted by mini-css-extract-plugin
export var legendIndicator = "_e3-1";
export var legendRight = "_e3-0";